import React from 'react';
import PropTypes from 'prop-types';

import styles from './EditCrew.css';
import EquipmentEdit from './EquipmentEdit';
import ResourceEdit from './ResourceEdit';

const defaultCrew = {
  equipment: null,
  resources: []
};

/**
 * Component for modifying a crew's composition.
 */
const EditCrew = ({ crew, equipment, onChange, resources, showpercentage }) => 
{
 
  return (
  <div className={styles.editCrew}>
    <EquipmentEdit crew={crew} equipment={equipment} onChange={(equipment) => onChange({ ...defaultCrew, ...crew, equipment })} />
    {crew && crew.resources && crew.resources.filter(r => !!r.resource).map((r, i) => (
      <ResourceEdit
        crewResource={r}
        key={i}
        showpercentage={showpercentage}
        onChange={(crewResource) => onChange({ ...defaultCrew, ...crew, resources: crew.resources.filter(r => !!r.resource).map((cr) => cr === r ? crewResource : cr ) })}
        onDelete={() => onChange({ ...defaultCrew, ...crew, resources: crew.resources.filter((cr) => cr !== r) })}
        resources={resources && resources.filter((r2) => r2.id === r.resource.id || !crew.resources.filter(r => !!r.resource).some((cr) => r2.id === cr.resource.id))}
      />
    ))}
    <ResourceEdit
      crewResource={null}
      onChange={(crewResource) => onChange({ ...defaultCrew, ...crew, resources: [...(crew ? crew.resources : []), crewResource] })}
      onDelete={null}
      showpercentage={showpercentage}
      resources={crew != null && crew.resource!=null ? resources.filter((r2) => !crew.resources.filter(r => !!r.resource).some((cr) => r2.id === cr.resource.id)):resources}
    />
  </div>
);
}

EditCrew.propTypes = {
  crew: PropTypes.object,
  equipment: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  resources: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default EditCrew;
